import React from 'react';
import moment from 'moment';
import { Stack, Typography } from '@mui/material';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { IntercomSyncSummary } from 'data/api/conversation.api';

// How long Intercom may go without delivering a webhook before the banner
// stops reading healthy. No product number has been set (collab #84 leaves it
// to Sam), so this is deliberately loose: prod has not had a day without
// deliveries (weekends run 36-90 parts/day), so 48h only fires on a real
// silence, while still catching a multi-day outage on day two.
export const INTERCOM_SILENCE_WARN_AFTER_HOURS = 48;

// Health is read from the webhook receipt alone. lastSuccessAt cannot carry
// it: the nightly batch stamps success after an empty run, so it reads fresh
// straight through a total webhook silence.
export const SyncFreshness = ({
  intercomSync,
}: {
  intercomSync: IntercomSyncSummary | null;
}) => {
  const lastReceivedAt = intercomSync?.lastReceivedAt;
  // No table yet, or no receipt on record: nothing to vouch for, so say
  // nothing rather than read green.
  if (!lastReceivedAt) return null;

  const received = moment(lastReceivedAt);
  const silent =
    moment().diff(received, 'hours', true) >= INTERCOM_SILENCE_WARN_AFTER_HOURS;

  if (silent) {
    return (
      <Stack direction="row" alignItems="center" gap={0.5}>
        <WarningAmberRoundedIcon sx={{ color: '#B42318', fontSize: '15px' }} />
        <Typography sx={{ fontSize: '12px', color: '#B42318' }}>
          Nothing from Intercom in {received.fromNow(true)} - recent messages
          may be missing
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" alignItems="center" gap={0.5}>
      <SyncRoundedIcon sx={{ color: '#356766', fontSize: '15px' }} />
      <Typography sx={{ fontSize: '12px', color: '#7D818C' }}>
        Intercom last delivered {received.fromNow()}
      </Typography>
    </Stack>
  );
};
